<div class="dialog">
    <img src="assets/svg/Sucess.svg" alt="">
    <h6 class="mt-2 text-center">Success !</h6>
    <h6 class="text-center mt-2">100 parts moved ready to ship</h6>
    <div class="button display-flex mt-3">
        <button (click)='close()' class="orange">close</button>
    </div>

</div>